import { render, staticRenderFns } from "./ModelIncomeUserRecord.vue?vue&type=template&id=696c26af&scoped=true&"
import script from "./ModelIncomeUserRecord.vue?vue&type=script&lang=js&"
export * from "./ModelIncomeUserRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModelIncomeUserRecord.vue?vue&type=style&index=0&id=696c26af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c26af",
  null
  
)

export default component.exports